import { AssetType } from "@src/types/intelligence-search";
import { DimensionIcon, MeasureIcon, FilterIcon } from "@src/pages/intelligence-search/icons";

const hexToRgba = (hex: string, opacity: number): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

const getMemberColor = (type?: AssetType) => {
    switch (type) {
        case "metric":
            return {
                backgroundColorPrimary: "#23A037",
                backgroundColorSecondary: "#D9F7BE",
                backgroundColorWithOpacity: hexToRgba("#D9F7BE", 0.7),
                backgroundColorWithOpacitySecondary: hexToRgba("#D9F7BE", 0.4),
                backgroundColorWithOpacityTertiary: hexToRgba("#D9F7BE", 0.2),
                backgroundColorWithOpacityQuaternary: hexToRgba("#D9F7BE", 0.1),
                textColor: "#23A037",
            };

        case "dimension":
            return {
                backgroundColorPrimary: "#E55626",
                backgroundColorSecondary: "#FFE7BA",
                backgroundColorWithOpacity: hexToRgba("#FFE7BA", 0.7),
                backgroundColorWithOpacitySecondary: hexToRgba("#FFE7BA", 0.4),
                backgroundColorWithOpacityTertiary: hexToRgba("#FFE7BA", 0.2),
                backgroundColorWithOpacityQuaternary: hexToRgba("#FFE7BA", 0.1),
                textColor: "#E55626",
            };

        case "filter":
            return {
                backgroundColorPrimary: "#2e86de",
                backgroundColorSecondary: "#E6F7FF",
                backgroundColorWithOpacity: hexToRgba("#E6F7FF", 0.7),
                backgroundColorWithOpacitySecondary: hexToRgba("#E6F7FF", 0.2),
                backgroundColorWithOpacityTertiary: hexToRgba("#E6F7FF", 0.2),
                backgroundColorWithOpacityQuaternary: hexToRgba("#E6F7FF", 0.1),
                textColor: "#2e86de",
            };
        default:
            return {
                backgroundColorPrimary: "#95a5a6",
                backgroundColorSecondary: "#ecf0f1",
                backgroundColorWithOpacity: hexToRgba("#ecf0f1", 0.4),
                backgroundColorWithOpacitySecondary: hexToRgba("#ecf0f1", 0.2),
                backgroundColorWithOpacityTertiary: hexToRgba("#ecf0f1", 0.2),
                backgroundColorWithOpacityQuaternary: hexToRgba("#ecf0f1", 0.1),
                textColor: "#95a5a6",
            };
    }
};

const getMemberIcon = ({
    disabled,
    memberType,
    textColor,
}: {
    disabled?: boolean;
    memberType: AssetType;
    textColor?: string;
}) => {
    switch (memberType) {
        case "metric":
            return <MeasureIcon disabled={disabled} textColor={textColor} />;
        case "dimension":
            return <DimensionIcon disabled={disabled} textColor={textColor} />;
        case "filter":
            return <FilterIcon disabled={disabled} textColor={textColor} />;

        default:
            return null;
    }
};

export { getMemberIcon, getMemberColor };
